import { render, staticRenderFns } from "./UniqueCallsTable.vue?vue&type=template&id=3fc517b7&"
import script from "./UniqueCallsTable.vue?vue&type=script&lang=js&"
export * from "./UniqueCallsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports